import IntroPrevious from './IntroPrevious';
import GuidedIntro from './GuidedIntro';

function App(props) {

  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var tryConnect = props.tryConnect;
  var history = props.history;
  var sortBy = props.sortBy;
  var setSortBy = props.setSortBy;
  var justLoadHistory = props.justLoadHistory;
  var isShowingPrevious = props.isShowingPrevious;
  var setIsShowingPrevious = props.setIsShowingPrevious;
  var setDoingWhat = props.setDoingWhat;
  var selectNew = props.selectNew;
  var doingWhat = props.doingWhat;
  var width = props.width;
  var height = props.height;
  var addToExtraScreen = props.addToExtraScreen;
  var scrollAmt = props.scrollAmt;
  var chains = props.chains;
  var logInState = props.logInState;
  var clickBack = props.clickBack;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var palette = props.palette;
  var changeTab = props.changeTab;

  if (isShowingPrevious === 'previous'){
    return <IntroPrevious userID={userID} signKey={signKey} sessionID={sessionID} tryConnect={tryConnect} history={history} sortBy={sortBy} setSortBy={setSortBy} justLoadHistory={justLoadHistory} doingWhat={doingWhat} setDoingWhat={setDoingWhat} clickBack={clickBack} addToExtraScreen={addToExtraScreen}/>
  }else{
    return <GuidedIntro chains={chains} history={history} isShowingPrevious={isShowingPrevious} setIsShowingPrevious={setIsShowingPrevious} selectNew={selectNew} width={width} height={height} addToExtraScreen={addToExtraScreen} scrollAmt={scrollAmt} logInState={logInState} clickBack={clickBack} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} palette={palette} changeTab={changeTab}/>

  }
//


//
}

export default App;
